// A reducer to maintain the maintenance state.
// @flow
import { ACTIONS } from './constants';

export type MaintenanceState = {
    enabled: boolean,
    pageURL: string
};

const DEFAULT_MAINTENANCE_STATE: MaintenanceState = {
    enabled: false,
    pageURL: ''
};

export default function maintenance(
    state: MaintenanceState = DEFAULT_MAINTENANCE_STATE,
    action: any = {}
) {
    switch (action.type) {
        case ACTIONS.ENABLE_MAINTENANCE:
            return {
                enabled: true,
                pageURL: action.pageURL
            };
        case ACTIONS.DISABLE_MAINTENANCE:
            return {
                ...DEFAULT_MAINTENANCE_STATE
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/state/reducer/maintenance/reducer.js